module.exports = __webpack_public_path__ + "img/ramn_4kl.dd7bc0e8.jpg";